import React, { useState } from "react";
import "./Solutions.css";

export default function Solutions() {
    const tabs = [
        {
            id: 1,
            label: "Prints of Business & Career Essentials",
            images: [
                { src: "/documentprinting.jpg", heading: "DOCUMENT PRINTING", link: "/document-printing-and-binding" },
                { src: "/businessessentials.jpg", heading: "PRINTING BUSINESS ESSENTIALS", link: "/business-card-printing" },
                { src: "/specialityprints.jpg", heading: "SPECIALTY PRINTS", link: "/photo-posters-printing" },
            ],
        },
        {
            id: 2,
            label: "Marketing & Promotional Materials",
            images: [
                { src: "/marketingmaterials.jpg", heading: "Printing of MARKETING MATERIALS", link: "/sytrene-sign-printing" },
                { src: "/invitation.jpg", heading: "Printing of Cards & Invitations", link: "/printing-invitations" },
            ],
        },
        {
            id: 3,
            label: "Banners, Signs & Posters",
            images: [
                { src: "/bannersprinting.jpg", heading: "Printing of BANNERS", link: "/banners-signs-and-posters" },
                { src: "/signsprinting.jpg", heading: "Printing of SIGNS", link: "/printing-corrugated-plastic-signs" },
                { src: "/posterprints.jpg", heading: "Printing of POSTERS", link: "/photo-posters-printing" },
            ],
        },
        {
            id: 4,
            label: "Printing & Design Ideas",
            images: [
                { src: "/industrypritng.jpg", heading: "Printing Solution for Industries", link: "/rack-card-design" },
            ],
        },
    ];

    const [selectedTab, setSelectedTab] = useState(tabs[0].id);

    const handleTabClick = (id) => {
        setSelectedTab(id);
    };

    const selectedTabContent = tabs.find((tab) => tab.id === selectedTab);

    return (
        <div className="tabs-container">
            <div className="sol-heading container">
                <h1 className="text-center">Your Partner for Custom Printing Solutions</h1>
                <p>
                    Printingy.com is India’s leading bulk printing service provider, offering high-quality, customised printing solutions for businesses across various industries. From creating vibrant marketing materials to producing durable and innovative print collaterals, we ensure precision, quality, and timely delivery in every project. Our expertise spans multiple sectors, including real estate, hospitality, education, retail, and more.

                  
                </p>
            </div>

            {/* Tab Navigation */}
            <div className="tabs">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        className={`tab ${selectedTab === tab.id ? "active" : ""}`}
                        onClick={() => handleTabClick(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            <div className="tab-content">
                <div className="images">
                    {selectedTabContent.images.map((image, index) => (
                        <div key={index} className="image-item">
                            <a href={image.link}>
                                <img src={image.src} alt={image.heading} className="tab-image" />
                                <h4 className="image-title">{image.heading}</h4>
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
